import { useContext, useEffect, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./app.scss";
import { ColorContext } from "./ColorContext/darkContext";
import AdminBottomNavigation from "./Components/Navbar/AdminBar";
import BottomNavigation from "./Components/Navbar/AppBar";
import Navbar from "./Components/Navbar/Navbar";
import Sidebar from "./Components/Sidebar/Sidebar";
import AccidentsPage from "./Pages/Accident/Accident";
import AddNew from "./Pages/AddNew/AddNew";
import DeliveryTable from "./Pages/Allocation/AllocationList";
import AllowancesTable from "./Pages/Allocation/Allowances";
import CustomerTable from "./Pages/Customers/Customers";
import AdminDashboard from "./Pages/DashBoard/AdminDashBoard";
import Detail from "./Pages/Detail/Detail";
import DriverAccidents from "./Pages/DriverApp/Accidents";
import LicenseForm from "./Pages/DriverApp/AddDriverDL";
import DriverDashboard from "./Pages/DriverApp/DashBoard";
import AllowanceSummaryPage from "./Pages/DriverApp/DriverAllowance";
import DriverMaintenaince from "./Pages/DriverApp/Maintenaince";
import DriverOrders from "./Pages/DriverApp/Orders";
import DriverSafety from "./Pages/DriverApp/Safety";
import TripFuelingTable from "./Pages/Fueling/Fueling";
import Home from "./Pages/Home/home";
import Login from "./Pages/Login/Login";
import VehicleChecklistApp from "./Pages/Maintenance/CheckList";
import Maintenance from "./Pages/Maintenance/RepairListing/ReapirListing";
import VehicleCard from "./Pages/MechanicApp/CheckList";
import MechanicDashboard from "./Pages/MechanicApp/Dashboard";
import FloatingActionButton from "./Pages/MechanicApp/FloatingButton";
import MechanicMaintenaince from "./Pages/MechanicApp/MainMaintenance";
import VehicleServiceCards from "./Pages/MechanicApp/VehicleServiceStatus";
import SafetyTalksPage from "./Pages/Safety/Safety";
import LicenseView from "./Pages/Users/LicenseView";
import UserTable from "./Pages/Users/Users";
import VehicleTable from "./Pages/Vehicles/Vehicle";

// Admin Layout Component
function AdminLayout() {
  const { darkMode } = useContext(ColorContext);
  const [isMobile, setIsMobile] = useState(false); // Default to false
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    // Set initial value and listen for resize
    const updateMobileStatus = () => {
      const mobile = window.innerWidth <= 768;
      console.log("Window width:", window.innerWidth, "isMobile:", mobile);
      setIsMobile(mobile);
    };

    // Run once on mount
    updateMobileStatus();

    // Add resize listener
    window.addEventListener("resize", updateMobileStatus);

    // Cleanup
    return () => window.removeEventListener("resize", updateMobileStatus);
  }, []);

  return (
    <div className={`admin-layout ${darkMode ? "dark" : ""}`}>
      <div className="dashboard">
        {!isMobile && <Sidebar />}

        <div className="content-wrapper">
          <Navbar />
          <ToastContainer />
          <main className="main-content">
            <Outlet />
          </main>
          {isMobile && (
            <div>
              <AdminBottomNavigation
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function DriverLayout() {
  const { darkMode } = useContext(ColorContext);
  const [activeTab, setActiveTab] = useState("");

  return (
    <div className={`driver-layout ${darkMode ? "dark" : ""}`}>
      <div className="dashboard driver-dashboard">
        <Navbar isDriverLayout={true} />
        <div className="content-wrapper">
          <ToastContainer />
          <main className="main-content">
            <Outlet activeTab={activeTab} />
          </main>
          <div className="bottom-navigation">
            <BottomNavigation
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

// Mechanic Layout Component
function MechanicLayout() {
  const { darkMode } = useContext(ColorContext);
  const [activeTab, setActiveTab] = useState("");

  return (
    <div className={`mechanic-layout ${darkMode ? "dark" : ""}`}>
      <div className="dashboard driver-dashboard">
        <Navbar isMechanicLayout={true} />
        <div className="content-wrapper">
          <ToastContainer />
          <main className="main-content">
            <Outlet activeTab={activeTab} />
          </main>
          <FloatingActionButton />
          {/* <div>
            <BottomNavigation
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}

function App() {
  const { darkMode } = useContext(ColorContext);

  return (
    <div className={darkMode ? "App dark" : "App"}>
      <BrowserRouter>
        <Routes>
          {/* Public home route */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Login Route */}
          <Route path="login" element={<Login />} />

          {/* Driver Routes */}
          <Route path="driver" element={<DriverLayout />}>
            <Route index element={<DriverDashboard />} />
            <Route path="dashboard" element={<DriverDashboard />} />
            <Route path="accidents" element={<DriverAccidents />} />
            <Route path="maintenance" element={<DriverMaintenaince />} />
            <Route path="orders" element={<DriverOrders />} />
            <Route path="safety" element={<DriverSafety />} />
            <Route path="licence" element={<LicenseForm />} />
            <Route path="allowance" element={<AllowanceSummaryPage />} />
          </Route>

          {/* Mechanic Routes */}
          <Route path="mechanic" element={<MechanicLayout />}>
            <Route index element={<MechanicDashboard />} />
            <Route path="dashboard" element={<MechanicDashboard />} />
            <Route path="accidents" element={<DriverAccidents />} />
            <Route path="maintenance" element={<MechanicMaintenaince />} />
            <Route path="checklist" element={<VehicleCard />} />
            <Route path="vehicle-service" element={<VehicleServiceCards />} />
          </Route>

          {/* Admin Routes */}
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<Home />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="users" element={<UserTable />} />
            <Route path="customers" element={<CustomerTable />} />
            <Route path="orders" element={<DeliveryTable />} />
            <Route path="vehicle" element={<VehicleTable />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="vehicle-service" element={<VehicleServiceCards />} />
            <Route path="checklist" element={<VehicleChecklistApp />} />
            <Route path="accident" element={<AccidentsPage />} />
            <Route path="safety" element={<SafetyTalksPage />} />
            <Route path="license" element={<LicenseView />} />
            <Route path="settings" element={<LicenseView />} />
            <Route path="fuelings" element={<TripFuelingTable />} />
            <Route path="allowances" element={<AllowancesTable />} />

            {/* Products Routes */}
            <Route path="products">
              <Route path=":productId" element={<Detail />} />
              <Route
                path="addnew"
                element={<AddNew title="Add New Product" type="PRODUCT" />}
              />
            </Route>
          </Route>

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;